var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { feathersServices } from 'src/feathers';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import Icon from 'antd/lib/icon';
import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/index.css';
import Page from '../../templates/Page';
import ListRound from './ListRound';
import ButtonAction from '../../components/utilities/ButtonAction';
var ListRoundPage = (function (_super) {
    __extends(ListRoundPage, _super);
    function ListRoundPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePatchRound = _this.handlePatchRound.bind(_this);
        return _this;
    }
    ListRoundPage.prototype.handlePatchRound = function (round) {
        return this.props.dispatch(feathersServices.rounds.patch(round.id, round));
    };
    ListRoundPage.prototype.render = function () {
        var workspaceEvent = this.props.workspaceEvent;
        return (React.createElement(Page, { documentTitle: "Rounds | " + workspaceEvent.event.nameShort, pageTitle: 'Rounds', pageAction: (React.createElement(Tooltip, { title: 'Rounds have to be inside a category. Go to "Categories" to setup a new round inside one.', placement: 'bottomRight' },
                React.createElement("div", null,
                    React.createElement(ButtonAction, { isDisabled: true },
                        React.createElement("a", null,
                            React.createElement(Icon, { type: 'file-add' }),
                            " Setup new round"))))) },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 24, md: 24 },
                    React.createElement(Card, { className: 'tableCard' },
                        React.createElement(ListRound, { event: workspaceEvent.event, categories: workspaceEvent.categories, rounds: workspaceEvent.rounds, routes: workspaceEvent.routes, handlePatchRound: this.handlePatchRound }))))));
    };
    return ListRoundPage;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceEvent: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
        categories: state.workspaceEvent.categories && state.workspaceEvent.categories.data,
        rounds: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data,
    },
}); };
export default connect(mapStateToProps)(ListRoundPage);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListRoundPage/index.tsx
// module id = 1087
// module chunks = 0